import styled from 'styled-components';
import { Theme } from '../../../layout/Basic';

export const PageHeader = styled.div`
  margin: 2%;
  h1 {
    font-size: 36px;
    font-family: 'Lora', serif;
    margin: 0;
    text-align: center;
    //text-transform: capitalize;
  }
  hr {
    color: ${Theme.color.hrBlue};
  }
`;

export const Right = styled.div`
  width: 215px;
  margin-left: auto;
`;

export const Content = styled.div`
  margin: 0 2% 0 2%;
  min-height: 300px;
  overflow-y: hidden;
`;
